/** @format */

/**
 * Если значение есть в массиве, то удалит его
 * Если значения нет в массиве, то добавит его
 * @param arr
 * @param value
 */

export const toggleArrayValue = <T extends string | number>(arr: T[], value: T): T[] => {
  if (arr.includes(value)) {
    return arr.filter(item => item !== value);
  }

  return [...arr, value];
};

/**
 * Отфильтрует значения из первого массива так, чтобы в нём не было значений из второго массива
 * @param arr1
 * @param arr2
 */

export const subtractArrays = <T extends string | number>(arr1: T[], arr2: T[]): T[] => {
  return arr1.filter(item => !arr2.includes(item));
};
